import Section from "@/components/Section";
import InfoCard from "@/components/UI-Kit/InfoCard";
import { PHONE, SUPPORT_EMAIL } from "@/utils/staticData/contacts";
import { helpDeskData } from "@/utils/staticData/dataConstants";
import { Grid, Link, Typography } from "@mui/material";

const GeneralSection = () => {
  return (
    <Section pt={0} pb={{ xs: 7.5, md: 10 }}>
      <Typography
        variant="h2"
        sx={{
          marginBottom: { xs: "24px", md: "32px" },
        }}
      >
        General Information
      </Typography>
      <Grid container spacing={2}>
        {helpDeskData.map((data, index, array) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <InfoCard
              title={data.title}
              description={data.description}
              iconUrl={data.iconUrl}
              path={data.path}
              withArrow={data.withArrow}
            >
              {index === array.length - 1 && (
                <>
                  Need technical support? Contact our team via email at{" "}
                  <Link
                    href={`mailto:${SUPPORT_EMAIL}`}
                    color="text.accent"
                    underline="hover"
                  >
                    {SUPPORT_EMAIL}{" "}
                  </Link>
                  or by phone{" "}
                  <Link
                    href={`tel:${PHONE.value}`}
                    color="text.accent"
                    underline="hover"
                  >
                    {PHONE.label}
                  </Link>
                </>
              )}
            </InfoCard>
          </Grid>
        ))}
      </Grid>
    </Section>
  );
};

export default GeneralSection;
